import { render, staticRenderFns } from "./PrtIcon.vue?vue&type=template&id=2b4598c3&"
import script from "./PrtIcon.js?vue&type=script&lang=js&"
export * from "./PrtIcon.js?vue&type=script&lang=js&"
import style0 from "./PrtIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports